import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export const BUYING_GROUP_PROFILE_PARAM = "buyingGroupProfile";

export const useBuyingGroupProfileParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const domain = searchParams.get(BUYING_GROUP_PROFILE_PARAM);

  const openBuyingGroupProfile = useCallback(
    (nextDomain: string) => {
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);
          next.set(BUYING_GROUP_PROFILE_PARAM, nextDomain);
          return next;
        },
        { replace: false },
      );
    },
    [setSearchParams],
  );

  const closeBuyingGroupProfile = useCallback(() => {
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete(BUYING_GROUP_PROFILE_PARAM);
        return next;
      },
      { replace: false },
    );
  }, [setSearchParams]);

  return { domain, openBuyingGroupProfile, closeBuyingGroupProfile };
};
